var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAssign = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chevron/Updown") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-Roles",
    transform: "translate(-1377.000000, -255.000000)",
    fill: "#6E6E6E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    transform: "translate(1373.000000, 250.790634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.26869639,4.24893404 L11.0699115,4.35045432 C11.3305764,4.35501591 11.5791544,4.46119383 11.7626818,4.64635504 L11.7626818,4.64635504 L19.458908,12.4117058 C19.8464546,12.8027325 19.845045,13.4334611 19.4557544,13.8227517 L19.4557544,13.8227517 L13.8170184,19.4614877 C13.4247454,19.8502555 12.7915867,19.8474254 12.4028047,19.4551667 L12.4028047,19.4551667 L4.70470602,11.6879264 C4.52605053,11.5076666 4.42261784,11.2662209 4.41537378,11.0125303 L4.41537378,11.0125303 L4.25135232,5.2312838 C4.26101573,4.6790836 4.71649619,4.23927063 5.26869639,4.24893404 L5.26869639,4.24893404 Z M6.2799731,6.26595542 L6.40371679,10.5602149 L13.1162815,17.3335908 L17.3377089,13.1121633 L10.6286798,6.34232295 L6.2799731,6.26595542 Z M9.48742074,7.7552936 C10.3045168,7.7552936 10.966904,8.4176808 10.966904,9.23477683 C10.966904,10.0518729 10.3045168,10.7142601 9.48742074,10.7142601 C8.67032472,10.7142601 8.00793751,10.0518729 8.00793751,9.23477683 C8.00793751,8.4176808 8.67032472,7.7552936 9.48742074,7.7552936 Z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAssign);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Assign.b26e63be63575a78a37e2fb2da7dabfe.svg";